
<script lang="ts">
import Etablissement from '@/extend/classes/Etablissement';
import SectionEtablissementList from '@/generated/sections/SectionEtablissementList.vue';
import {RessourceFwkButton, FwkButtons} from '@/ressources/globalRessources';
import {storeEtablissement, storeSession} from '@/generated/stores';
import UserProfile from '@/framework/base/classes/UserProfile';
import {defineComponent} from "vue";
import SearchFilterInput from "@/framework/base/components/SearchFilterInput.vue";
import Route from "@/extend/classes/Route.ts";
import {Fiches, Modules, Sections} from "@/generated/classes/AppSchema.ts";

export default defineComponent({
  components: {SearchFilterInput},
  extends: SectionEtablissementList,
  data() {
    const selected: Etablissement[] = [];
    return {
      selected,
      dialogOpen: false,
      isCardView: true
    }
  },
  computed: {
    addLabel(): string {
      return RessourceFwkButton(FwkButtons.NEW_ETABLISSEMENT).label;
    },
    isClient(): boolean {
      let res = false;
      const user = storeSession.connectedUser;
      if (user && user.id > 0) {
        res = UserProfile.isClient;
      }
      return res;
    },
    canAdd(): boolean {
      return this.isClient;
    },
    showToggle() : boolean {
      return true;
    },
    placeholder() {
      return "Rechercher un établissement, SIRET, code APE,...";
    },
  },
  methods: {
    extendLabel(name: string, item: number, obj: unknown): string {
      let res = '';
      if (name == 'nom') {
        const etablissement = obj as Etablissement;
        if (etablissement.alias != '') {
          res = etablissement.alias;
        } else {
          res = etablissement.nom;
        }
      }
      return res;
    },
    selectItemCard(etab: Etablissement): void {
      const obj = etab;
      const route = new Route();
      route.module = Modules.ETABLISSEMENT;
      route.fiche = Fiches.ETABLISSEMENT_ABSTRACT;
      route.ficheObjId = obj.id;
      this.$emit('selectItem', route);
    },
    addItem(): void {
      const obj = storeEtablissement.createNewEtablissement();
      const route = new Route();
      route.module = Modules.ETABLISSEMENT;
      route.fiche = Fiches.ETABLISSEMENT_ABSTRACT;
      route.section = Sections.ETABLISSEMENT_IDENTITE;
      route.ficheObjId = obj.id;
      this.$emit('selectItem', route);
    },
    getInitials(etab: Etablissement): string {
      const name = etab.alias ? etab.alias : etab.nom;
      const initials = name.split(/[ -]+/);
      if (initials.length > 1) {
        return initials[0][0] + initials[initials.length - 1][0];
      } else {
        return initials[0][0] + initials[0][1];
      }
    }
  }
})
</script>